var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscoverPostSizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_611_439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7103 15.2737C36.7051 14.3446 33.9626 12.2248 30.1574 12.5297C27.5297 12.7475 25.6056 14.0106 24.5 14.9979C23.3944 14.0106 21.4703 12.7475 18.8426 12.5297C15.0374 12.2248 12.2949 14.3446 11.2897 15.2737C10.7872 15.7383 10.5 16.4207 10.5 17.1176V32.4638C10.5 33.3785 10.9595 34.177 11.7349 34.6271C12.5103 35.0772 13.4867 35.0772 14.2764 34.6271C15.6692 33.814 17.1482 33.4511 18.6703 33.5818C21.3554 33.7995 23.0785 35.4401 23.6959 36.137C23.8969 36.3693 24.1841 36.5 24.5 36.5C24.8159 36.5 25.0887 36.3693 25.3041 36.137C25.9215 35.4401 27.659 33.814 30.3297 33.5818C31.8518 33.4511 33.3308 33.814 34.7236 34.6271C35.5133 35.0917 36.4897 35.0917 37.2651 34.6271C38.0405 34.177 38.5 33.364 38.5 32.4638V17.1176C38.5 16.4062 38.2128 15.7383 37.7103 15.2737ZM18.8426 31.404C18.5985 31.3894 18.34 31.3749 18.0815 31.3749C16.4015 31.3749 14.7215 31.8395 13.1851 32.7397C12.9985 32.8413 12.8549 32.7832 12.7974 32.7397C12.6969 32.6816 12.6395 32.58 12.6395 32.4638V17.1176C12.6395 17.1176 12.6538 16.9434 12.74 16.8708C13.7308 15.9561 15.8128 14.4607 18.6559 14.693C21.0108 14.8817 22.6333 16.1739 23.4087 16.9434V33.03C22.2887 32.2751 20.7523 31.5491 18.8282 31.3894L18.8426 31.404ZM36.3462 32.4638C36.3462 32.5945 36.2887 32.6816 36.1882 32.7397C36.1308 32.7687 35.9872 32.8413 35.8005 32.7397C34.0344 31.7088 32.0815 31.2443 30.1574 31.404C28.2333 31.5637 26.6969 32.2896 25.5769 33.0446V16.9579C26.3523 16.1739 27.9749 14.8963 30.3297 14.7075C33.1872 14.4752 35.2549 15.9706 36.2456 16.8853C36.3318 16.9579 36.3462 17.0595 36.3462 17.1321V32.4783V32.4638Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_611_439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverPostSizer);
export default __webpack_public_path__ + "static/media/discoverPostSizer.f63c63b1.svg";
export { ForwardRef as ReactComponent };